module.exports = __webpack_public_path__ + "static/media/naming3DShapes.71473d57.jpg";